import { cn } from "@pulsex/utils";
import { MangoBlockProps } from "@/types/general";
import MediaGalleryCarousel from "./shared/Carousel/MediaGalleryCarousel";
import Link from "next/link";
import SocialsList from "./DetailsPage/Socials";

export default function InPicutersDetails({ block }: MangoBlockProps) {
    const widget = block?.getMainWidget();
    if (!widget || !widget?.posts?.length) return;
    const post = widget.posts[0];
    const source = post?.findMeta((m) => m.key === "source");

    return (
        <section className={cn("container mx-auto my-5")}>
            <h1 className="font-bold text-3xl dark:text-white mt-6 mb-3 lg:text-2xl lg:font-black">
                {post?.title}
            </h1>
            <div className="flex flex-wrap text-[15px] text-gray-400 dark:text-white/50 mb-2 divide-x divide-gray-400">
                {source && (
                    <span>
                        {source.title}: {source.value} &nbsp;
                    </span>
                )}

                {post.displayDate && <span>&nbsp; {post.displayDate} &nbsp;</span>}
                {post.shares !== null ? <span>&nbsp; {post.shares || 0} Shares</span> : ""}
            </div>
            <p className="italic text-lg dark:text-white mb-2">
                {post?.summary}
            </p>
            <SocialsList post={post}/>
            <MediaGalleryCarousel post={post} />
            <div className="flex flex-wrap mt-4">
                {post?.keywords.map((Tab: any, index: any) => (
                    <Link
                        href={`/tags/${Tab}`}
                        key={index}
                        className="border border-primary rounded-lg px-5 py-1 transition-all mr-4 mt-4 lg:mr-2 lg:mt-2 hover:bg-primary text-black/70 dark:text-white/80 hover:text-white/80"
                    >
                        <span className="text-lg lg:text-xs">{Tab}</span>
                    </Link>
                ))}
            </div>
        </section>
    );
}
